import IconButton from '@/features/ui/buttons/components/IconButton'
import DeleteIcon from '@/features/ui/icons/components/DeleteIcon'
import { FC } from 'react'

interface DeleteButtonProps {
    disabled?: boolean
    onPress: () => void
}

const DeleteButton: FC<DeleteButtonProps> = ({ disabled, onPress }) => {
    return (
        <IconButton
            disabled={disabled}
            type="outline"
            color="secondary"
            size={44}
            onPress={onPress}
            Icon={DeleteIcon}
            testID="delete-button"
        />
    )
}

export default DeleteButton
